export type Period = { start: string; end: string };
const day = 86400000;
export function dateKey(date: Date) { return `${date.getFullYear()}-${String(date.getMonth()+1).padStart(2,'0')}-${String(date.getDate()).padStart(2,'0')}`; }
export function currentPeriod(now = new Date()): Period { return { start: dateKey(new Date(now.getFullYear(),now.getMonth(),1)), end: dateKey(now) }; }
function stamp(value: string) { return Date.parse(`${value}T00:00:00Z`); }
export function periodError(period: Period) {
  const {start,end} = period;
  const valid = (value: string) => /^\d{4}-\d{2}-\d{2}$/.test(value) && Number.isFinite(stamp(value)) && new Date(stamp(value)).toISOString().slice(0,10) === value;
  if (!valid(start) || !valid(end)) return 'Choose a valid start and end date.';
  if (end < start) return 'End date must be on or after start date.';
  if ((stamp(end)-stamp(start))/day > 366) return 'Choose a reporting period of 367 days or fewer.';
  return '';
}
export function previousPeriod(period: Period): Period {
  const size = stamp(period.end)-stamp(period.start)+day;
  return {start:new Date(stamp(period.start)-size).toISOString().slice(0,10),end:new Date(stamp(period.start)-day).toISOString().slice(0,10)};
}
export function trendPeriods(end: string): (Period & { label: string })[] {
  const date = new Date(`${end}T12:00:00`);
  return Array.from({length:6},(_,index) => {
    const first = new Date(date.getFullYear(),date.getMonth()-5+index,1);
    const last = new Date(first.getFullYear(),first.getMonth()+1,0);
    return {start:dateKey(first),end:index===5?end:dateKey(last),label:first.toLocaleDateString('en-US',{month:'short',year:'2-digit'})};
  });
}
export function money(value: string, currency = 'USD') {
  return new Intl.NumberFormat('en-US',{style:'currency',currency}).format(Number(value));
}

export type PeriodPreset = 'This Month' | 'Last Month' | 'Last 90 Days' | 'Custom Range';
export const periodPresets: PeriodPreset[] = ['This Month', 'Last Month', 'Last 90 Days', 'Custom Range'];
export function presetPeriod(preset: Exclude<PeriodPreset, 'Custom Range'>, now = new Date()): Period {
  if (preset === 'This Month') return currentPeriod(now);
  if (preset === 'Last Month') return {start:dateKey(new Date(now.getFullYear(),now.getMonth()-1,1)),end:dateKey(new Date(now.getFullYear(),now.getMonth(),0))};
  // Calendar arithmetic preserves 90 inclusive dates across daylight-saving changes.
  return {start:dateKey(new Date(now.getFullYear(),now.getMonth(),now.getDate()-89)),end:dateKey(now)};
}
